export default {
	state: {
		incidents: [],
		types: [],
		severities: [],
		statuses: []
	},

	actions: {
		getIncidents(actionContext) {
			return new Promise(async (resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })
					
					var profile = actionContext.rootState.Profile.profile
					var customers = actionContext.rootState.Customers.customers

					if (customers.length < 1)
						await actionContext.dispatch("Customers/getCustomers", null, { root: true }).then(() => {
							customers = actionContext.rootState.Customers.customers
						})
					
					var columns = ""
						+ "i.*"
						+ ", dddlostatus.name as statusname";

					var tableName = ""
						+ "@db.incident i"
						+ " inner join @db.def_tables dtstatus on dtstatus.name = 'incident'"
						+ " inner join @db.def_fields dfstatus on dtstatus.id = dfstatus.tableid and dfstatus.name = 'status'"
						+ " inner join @db.def_ddloptions dddlostatus on dfstatus.id = dddlostatus.fieldid and i.status = dddlostatus.value"
						;
					var filter = ""
						+ "i.inactive = 0"
						+ ` and ${profile.accounttype == 2 ? "i.allowstaffaccess" : "i.allowclientaccess"} = 1`
						+ ` and ${profile.isadmin ? "1=1" : `i.clientid in (${customers.map(x => x.id).join()})`}`
						+ " order by i.date desc";

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/GetTableData?columns=${columns}&tableName=${tableName}&filter=${filter}`)
						.then(response => {
							var records = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response.data)

							actionContext.commit("setIncidents", records)
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		getIncidentTypes(actionContext) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					actionContext.rootGetters["MopaneApi/getInstance"].get("Service/GetIncidentTypes")
						.then(response => {
							var records = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response.data)

							actionContext.commit("setTypes", records)
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		getIncidentSeverity(actionContext) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					var columns = ""
						+ "dddlo.name"
						+ ", dddlo.value";
					var tableName = ""
						+ "@db.def_tables dt"
						+ " inner join @db.def_fields df on dt.id = df.tableid"
						+ " inner join @db.def_ddloptions dddlo on df.id = dddlo.fieldid";
					var filter = ""
						+ "dt.name = 'incident'"
						+ " and df.name = 'severity'";

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/GetTableData?columns=${columns}&tableName=${tableName}&filter=${filter}`)
						.then(response => {
							var records = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response.data)

							actionContext.commit("setSeverities", records)
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		getIncidentStatuses(actionContext) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					var columns = ""
						+ "dddlo.name"
						+ ", dddlo.value";
					var tableName = ""
						+ "@db.def_tables dt"
						+ " inner join @db.def_fields df on dt.id = df.tableid"
						+ " inner join @db.def_ddloptions dddlo on df.id = dddlo.fieldid";
					var filter = ""
						+ "dt.name = 'incident'"
						+ " and df.name = 'status'";

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/GetTableData?columns=${columns}&tableName=${tableName}&filter=${filter}`)
						.then(response => {
							var records = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response.data)

							actionContext.commit("setStatuses", records)
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		save(actionContext, parameters) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					actionContext.rootGetters["MopaneApi/getInstance"].post("Service/SaveIncidentv2", parameters)
						.then(response => {
							actionContext.commit("Toasts/showSuccess", { title: "Save", content: "Incident saved!" }, { root: true })

							var profile = actionContext.rootState.Profile.profile

							if (!profile.email) {
								actionContext.commit("Loading/hide", null, { root: true })

								resolve(response.data)

								return
							}
							var email = {
								email: profile.email,
								subject: "New incident report",
								message: `From Brevity:<br /><br />You have just submitted a new ${parameters.severityname} incident report with id #${response.data}.<br /><br />Regards,<br />Brevity Care Software<br /><i>This is an automated system generated email</i>`
							}

							actionContext.rootGetters["MopaneApi/getInstance"].post("Service/SendEmail", email)
								.then(() => {
									actionContext.commit("Toasts/showSuccess", { title: "Save", content: "Email sent!" }, { root: true })
									actionContext.commit("Loading/hide", null, { root: true })

									resolve(response.data)
								})
								.catch(response => {
									actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
									actionContext.commit("Loading/hide", null, { root: true })

									reject(response)
								})
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		}
	},

	mutations: {
		setIncidents(state, incidents) {
			state.incidents = incidents
		},
		setTypes(state, types) {
			state.types = types
		},
		setSeverities(state, severities) {
			state.severities = severities
		},
		setStatuses(state, statuses) {
			state.statuses = statuses
		}
	},

	namespaced: true
}